import React from 'react';
import { Dialog, FormGroup, Input } from '@tencent/spaui';

import useInput from '../../../../hooks/useInput';

const MyDialog = (props) => {
  const fieldstyle = {
    width: '880px',
  };

  const originalFieldName = useInput({
    required: true,
    value: props.model == 'edit' ? props.editItem.originalFieldName : '',
  });

  const field1 = useInput({
    required: true,
    value: props.model == 'edit' ? props.editItem.splittedFieldName1 : '',
  });

  const field2 = useInput({
    required: true,
    value: props.model == 'edit' ? props.editItem.splittedFieldName2 : '',
  });

  const field3 = useInput({
    value: props.model == 'edit' ? props.editItem.splittedFieldName3 : '',
  });

  const field4 = useInput({
    value: props.model == 'edit' ? props.editItem.splittedFieldName4 : '',
  });

  const handleSummit = () => {
    originalFieldName.checkValid();
    field1.checkValid();
    field2.checkValid();

    if (!originalFieldName.valid || !field1.valid || !field2.valid) {
      return;
    }
    const data = {
      originalFieldName: originalFieldName.value,
      splittedFieldName1: field1.value,
      splittedFieldName2: field2.value,
      splittedFieldName3: field3.value,
      splittedFieldName4: field4.value,
    };

    if (props.model == 'edit') {
      data.fieldSplittingId = props.editItem.fieldSplittingId;
    }

    props.onSubmit(data);
  };

  return (
    <Dialog
      backdrop
      type="normal"
      show={props.show}
      onClose={props.handleClose}
      onSubmit={handleSummit}
      onCancel={props.handleClose}
      title="多级字段拆解配置"
      style={fieldstyle}
      className="modal-field-break"
    >
      <div className="field-break">
        <div className="field-trans-form">
          <div className="trans trans-tt">
            <div className="bef">
              <p className="name">原始字段名</p>
            </div>
            <span className="center-wd"></span>
            <div className="aft">
              <p className="name">拆解后字段名</p>
            </div>
            <span className="iconarea"></span>
          </div>
          <div className="trans trans-con">
            <div className="bef">
              <FormGroup status={originalFieldName.status}>
                <Input placeholder="请输原始字段的名称" {...originalFieldName} />
              </FormGroup>
            </div>
            <span className="center-wd">拆解为</span>
            <div className="aft aft-more">
              <FormGroup status={field1.status}>
                <Input placeholder="一级字段名" {...field1} />
              </FormGroup>
              <FormGroup status={field2.status}>
                <Input placeholder="二级字段名" {...field2} />
              </FormGroup>
              <Input placeholder="三级字段名(选填)" {...field3} />
              <Input placeholder="四级字段名(选填)" {...field4} />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default MyDialog;
